import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";
import * as zIndexes from "zIndexes.module.scss";

export const useStyles = makeStyles((theme) => ({
  popoverPopper: {
    zIndex: zIndexes.notificationsZIndex,
  },
  popoverCard: {
    padding: "9px 16px",
  },
  closeButton: {
    minWidth: 22,
    height: 22,
    transform: "scale(0.75)",
    marginLeft: 8,
  },
  popoverCardPresentationMode: {
    backgroundColor: "#2C2F3C",
    border: "1px solid #333544",
  },
  textPresentationMode: {
    color: theme.palette.white,
    opacity: 0.7,
  },
  closeButtonPresentationMode: {
    color: theme.palette.white,
    opacity: 0.7,
  },
}));
